module.exports = __webpack_public_path__ + "img/png-icon.3c0ca1f0.png";